import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {Comment, CommentCreateRequest, CommentUpdateRequest} from "./model/comment";
import {BelongsTo} from "./model/common";

@Injectable()
export class CommentService {
  constructor(private http: HttpClient) {
  }

  list(belongsTo: BelongsTo | undefined, belongsToId: string): Observable<Comment[]> {
    const querystring = belongsTo ? "?belongsTo=" + belongsTo + "&belongsToId=" + belongsToId : "";
    return this.http.get<Comment[]>(environment.apiUrl + "/comment" + querystring)
  }

  create(request: CommentCreateRequest): Observable<Comment> {
    return this.http.post<Comment>(environment.apiUrl + "/comment", request)
  }

  delete(id: string): Observable<any> {
    return this.http.delete(environment.apiUrl + "/comment/" + id)
  }

  update(id: string, request: CommentUpdateRequest): Observable<Comment> {
    return this.http.put<Comment>(environment.apiUrl + "/comment/" + id, request)
  }
}
